import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

const selectConfigsHashMaps = (store: StoreSchema) => store.configurations.configsHashMaps

export const selectConfigsHashByGuid = (guid: string) => createSelector(
    [selectConfigsHashMaps],
    (configsHashMap) => configsHashMap[guid]
)

const selectProductConfigs = (store: StoreSchema) => store.configurations.productsConfigurationsDefault

export const selectHashmapFromWithinConfig = (guid: string) => createSelector(
    [selectProductConfigs],
    (productsConfigurationsDefault) => productsConfigurationsDefault[guid]?.configuration_hash_map
)